module.exports = __webpack_public_path__ + "img/A05.6b9a12aa.jpg";